import { get, post, put, deleted } from '..';
import routes from './routes';

const BayServices = {
  createBay: async (obj) => {
    const data = await post(routes.createBay, obj);
    return data;
  },
  getBays: async (params) => {
    const data = await get(routes.getBays, params);
    return data;
  },
  getBayById: async (id) => {
    const data = await get(routes.getBayById + id);
    return data;
  },
  updateBay: async (id, obj) => {
    const data = await put(routes.updateBay + id, obj);
    return data;
  },
  deleteBay: async (id) => {
    const data = await deleted(routes.deleteBay + id);
    return data;
  },
}

export default BayServices